import { Link } from "react-router";
import HoverCardWrapper from "../HoverCardWrapper";
import { ExternalLinkIcon } from "@radix-ui/react-icons";
import { sentenceCase } from "@/util/sentenceCase";

interface SourceData {
  source: string;
  sourceUrl: string | null;
}

export default function CellSource({ data }: { data: SourceData }) {
  const { source, sourceUrl } = data;
  return sourceUrl ? (
    <HoverCardWrapper
      trigger={
        <span className="flex justify-start items-start gap-1">
          {source}{" "}
          {sourceUrl !== "" && <ExternalLinkIcon className="inline h-2 w-2" />}
        </span>
      }
      content={
        <p className="text-sm">
          <Link to={sourceUrl} target="_blank" rel="noopener noreferrer">
            {sourceUrl}
          </Link>
        </p>
      }
    />
  ) : (
    <span className="inline">{sentenceCase(source)}</span>
  );
}